<mat-tab-group [selectedIndex]="selected" #tabs>
    <mat-tab
        *ngFor="let part of model; trackBy: id; last as last"
        [disabled]="part.disabled && config.behavior.restrictPartChange"
    >
        <ng-template mat-tab-label>
            <vi-quest-validation-icon [error]="part.valid ? false : undefined"></vi-quest-validation-icon>
            <vi-quest-validation-icon [error]="part.valid === false ? true : undefined"></vi-quest-validation-icon>
            <vi-icon *ngIf="part.icon" [icon]="part.icon"></vi-icon>
            <span>{{ part.title }}</span>
        </ng-template>
        <div fxLayout="row" *ngIf="config?.behavior?.resettableParts?.enabled">
            <button
                mat-raised-button
                color="primary"
                type="button"
                class="reset"
                (click)="reset()"
                [disabled]="checking || !resettable()"
            >
                {{ prefixed('button.reset') | translate }}
            </button>
        </div>
        <h2>{{ part.headline }}</h2>
        <p [innerHTML]="part.description | trustHtml"></p>
        <form>
            <div fxLayout="row wrap">
                <ng-container *ngIf="part.groups?.length">
                    <vi-quest-group
                        *ngFor="let group of part.groups; trackBy: id"
                        fxFlex="100"
                        [model]="group"
                        (check)="changed($event)"
                        [hideIfEmpty]="config.behavior.hideEmptyGroups"
                        [disabled]="checking"
                    >
                    </vi-quest-group>
                </ng-container>
                <ng-container *ngIf="part.questions?.length">
                    <ng-container *ngFor="let question of part.questions; trackBy: id">
                        <vi-quest-question
                            attr.quest-selector="{{ question.id | lowercase }}"
                            [attr.class]="question.appearance"
                            fxFlex="100"
                            [fxFlex.gt-sm]="question.appearance === 'full' ? 100 : 50"
                            [model]="question"
                            [error]="question.error"
                            (check)="changed($event)"
                            [checking]="checking"
                        >
                        </vi-quest-question>
                        <vi-quest-question
                            attr.quest-selector="{{ question.id | lowercase }}"
                            *ngIf="question.appearance === 'half-standalone' || question.appearance === 'full'"
                            [model]="{ type: 'empty', appearance: question.appearance }"
                            [fxHide]="question.appearance === 'full'"
                        >
                        </vi-quest-question>
                    </ng-container>
                </ng-container>
            </div>

            <ng-container *ngIf="part.submit || (last && part.submit !== false); then submitButton"></ng-container>
            <ng-container *ngIf="!last && !part.submit; then nextButton"></ng-container>
            <ng-container
                *ngIf="
                    selected > 0 && (!model[selected - 1].disabled || !config.behavior.restrictPartChange);
                    then prevButton
                "
            ></ng-container>
        </form>

        <ng-template #prevButton>
            <button class="prev" mat-button color="default" (click)="prev()" type="button" [disabled]="checking">
                {{ prefixed('button.prev') | translate }}
            </button>
        </ng-template>
        <ng-template #nextButton>
            <button mat-raised-button color="primary" type="button" (click)="next()" [disabled]="checking" class="next">
                {{ prefixed('button.next') | translate }}
            </button>
        </ng-template>
        <ng-template #submitButton>
            <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="submit()"
                [disabled]="submitDisabled || checking"
                class="submit"
            >
                <ng-container *ngIf="!part.submit?.key">{{
                    prefixed('button.' + ((part.submit === true && 'submit') || part.submit || 'submit')) | translate
                }}</ng-container>
                <ng-container *ngIf="part.submit?.key">{{
                    prefixed('button.' + part.submit.key) | translate: part.submit.params
                }}</ng-container>
            </button>
        </ng-template>
    </mat-tab>
</mat-tab-group>
